"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyGroupBy = void 0;
const utilityFunctions_1 = require("../../utilities/utilityFunctions");
function applyGroupBy(factory, src, keySelector, equalityComparer) {
    function* generator() {
        if (equalityComparer) {
            const groupings = [];
            for (const item of src) {
                const key = keySelector(item);
                let groupExists = false;
                for (let i = 0; i < groupings.length; i++) {
                    const [groupKey, group] = groupings[i];
                    if (equalityComparer(key, groupKey)) {
                        groupExists = true;
                        group.push(item);
                    }
                }
                if (!groupExists) {
                    groupings.push([key, [item]]);
                }
            }
            for (let i = 0; i < groupings.length; i++) {
                const [groupKey, group] = groupings[i];
                yield factory.createGroupedEnumerable(groupKey, (0, utilityFunctions_1.getIterableGenerator)(group));
            }
        }
        else {
            for (const [groupKey, group] of (0, utilityFunctions_1.toKeyMap)(src, keySelector)) {
                yield factory.createGroupedEnumerable(groupKey, (0, utilityFunctions_1.getIterableGenerator)(group));
            }
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyGroupBy = applyGroupBy;
//# sourceMappingURL=applyGroupBy.js.map